const SET_PROPERTY = 'SET_PROPERTY_CREATE_PAGE';
const SET_PREVIEW_PROPERTY = 'SET_PREVIEW_PROPERTY_CREATE_PREVIEW';
const SET_PREVIEW_PROPERTY_WITHOUT_TRACKING = 'SET_PREVIEW_PROPERTY_WITHOUT_TRACKING_CREATE_PREVIEW';

const RESET_VIDEO_SETTINGS = 'RESET_VIDEO_SETTINGS';
const UPDATE_VIDEO_SETTINGS = 'UPDATE_VIDEO_SETTINGS_CREATE_PREVIEW';
const UPDATE_AUDIO_SETTINGS = 'UPDATE_AUDIO_SETTINGS_CREATE_PAGE';
const UPDATE_VISUALIZER_SETTINGS = 'UPDATE_VISUALIZER_SETTINGS_CREATE_PREVIEW';
const UPDATE_VISUALIZER_LAYERS_TYPE = 'UPDATE_VISUALIZER_LAYERS_TYPE_CREATE_PREVIEW';
const UPDATE_BACKGROUND_SETTINGS = 'UPDATE_BACKGROUND_SETTINGS_CREATE_PREVIEW';
const UPDATE_ELEMENTS_SETTINGS = 'UPDATE_ELEMENTS_SETTINGS_CREATE_PREVIEW';

const SET_VIDEO_DIRTY = 'SET_VIDEO_DIRTY_CREATE_PAGE';
const SET_AUDIO_DIRTY = 'SET_AUDIO_DIRTY_CREATE_PAGE'

const OPEN_AUDIO_DIALOG = 'OPEN_AUDIO_DIALOG_CREATE_PAGE';
const CLOSE_AUDIO_DIALOG = 'CLOSE_AUDIO_DIALOG_CREATE_PAGE';

const SET_SHOW_UPDATE_DIALOG = 'SET_SHOW_UPDATE_DIALOG_CREATE_PAGE';
const SET_SHOW_ADVANCED_SETTINGS = 'SET_SHOW_ADVANCED_SETTINGS_CREATE_PAGE';
const SET_PREVIEW_RESOLUTION = 'SET_PREVIEW_RESOLUTION_CREATE_PAGE';

const UPDATE_IMAGES_LIBRARY = 'UPDATE_IMAGES_LIBRARY_CREATE_PAGE';
const CLEAR_IMAGES_LIBRARY = 'CLEAR_IMAGES_LIBRARY_CREATE_PAGE';

const UPDATE_LYRICS_SEGMENT = 'UPDATE_LYRICS_SEGMENT_CREATE_PREVIEW';
const REMOVE_LYRICS_SEGMENT = 'REMOVE_LYRICS_SEGMENT_CREATE_PREVIEW';
const REMOVE_LYRICS_SEGMENTS = 'REMOVE_LYRICS_SEGMENTS_CREATE_PREVIEW';
const UPDATE_LYRICS_STYLE = 'UPDATE_LYRICS_STYLE_CREATE_PREVIEW'; 
const SET_LYRICS_SEGMENT_TIME = 'SET_LYRICS_SEGMENT_TIME_CREATE_PREVIEW';
const ADD_LYRICS_SEGMENT = 'ADD_LYRICS_SEGMENT_CREATE_PREVIEW';
const ADD_LYRICS_SEGMENTS = 'ADD_LYRICS_SEGMENTS_CREATE_PREVIEW'
const CLEAR_LYRICS = 'CLEAR_LYRICS_CREATE_PREVIEW';
const SELECT_OR_DESELECT_SEGMENTS = 'SELECT_OR_DESELECT_SEGMENTS_CREATE_PREVIEW'; 

const UNDO = 'UNDO_CREATE_PREVIEW';
const REDO = 'REDO_CREATE_PREVIEW';
const CLEAR_ACTIONS_HISTORY = 'CLEAR_ACTIONS_HISTORY_CREATE_PREVIEW';

const UPDATE_TEXT_ELEMENT = 'UPDATE_TEXT_ELEMENT_CREATE_PREVIEW';
const ADD_TEXT_ELEMENT = 'ADD_TEXT_ELEMENT_CREATE_PREVIEW';
const REMOVE_TEXT_ELEMENT = 'REMOVE_TEXT_ELEMENT_CREATE_PREVIEW';
const DUPLICATE_TEXT_ELEMENT = 'DUPLICATE_TEXT_ELEMENT_CREATE_PREVIEW';
const UPDATE_VISUALIZER_REFLECTION_TYPE = 'UPDATE_VISUALIZER_REFLECTION_TYPE_PREVIEW';

const UPDATE_PARTICLE_ITEM = 'UPDATE_PARTICLE_ITEM_CREATE_PREVIEW';
const ADD_PARTICLE_ITEM = 'ADD_PARTICLE_ITEM_CREATE_PREVIEW';
const REMOVE_PARTICLE_ITEM = 'REMOVE_PARTICLE_ITEM_CREATE_PREVIEW';
const DUPLICATE_PARTICLE_ITEM = 'DUPLICATE_PARTICLE_ITEM_CREATE_PREVIEW';

const UPDATE_IMAGE_ELEMENT = 'UPDATE_IMAGE_ELEMENT_CREATE_PREVIEW';
const ADD_IMAGE_ELEMENT = 'ADD_IMAGE_ELEMENT_CREATE_PREVIEW';
const REMOVE_IMAGE_ELEMENT = 'REMOVE_IMAGE_ELEMENT_CREATE_PREVIEW';
const DUPLICATE_IMAGE_ELEMENT = 'DUPLICATE_IMAGE_ELEMENT_CREATE_PREVIEW';
const CHANGE_IMAGE_ELEMENT_ORDER = 'CHANGE_IMAGE_ELEMENT_ORDER_CREATE_PREVIEW';

const ADD_WAVE_LAYER = 'ADD_WAVE_LAYER_CREATE_PREVIEW';
const UPDATE_WAVE_LAYER = 'UPDATE_WAVE_LAYER_CREATE_PREVIEW';
const UPDATE_WAVE_LAYER_CUSTOM_SETTINGS = 'UPDATE_WAVE_LAYER_CUSTOM_SETTINGS_CREATE_PREVIEW';
const UPDATE_WAVE_LAYER_SPIN_SETTINGS = 'UPDATE_WAVE_LAYER_SPIN_SETTINGS_CREATE_PREVIEW';
const REMOVE_WAVE_LAYER = 'REMOVE_WAVE_LAYER_CREATE_PREVIEW';
const DUPLICATE_WAVE_LAYER = 'DUPLICATE_WAVE_LAYER_CREATE_PREVIEW';
const CHANGE_WAVE_LAYER_ORDER = 'CHANGE_WAVE_LAYER_ORDER_CREATE_PREVIEW';

const UPDATE_ASPECT_RATIO = 'UPDATE_ASPECT_RATIO';

export default {
    SET_PROPERTY,
    SET_PREVIEW_PROPERTY,
    UPDATE_VIDEO_SETTINGS,
    RESET_VIDEO_SETTINGS,
    UPDATE_AUDIO_SETTINGS,
    SET_VIDEO_DIRTY,
    SET_AUDIO_DIRTY,
    OPEN_AUDIO_DIALOG,
    CLOSE_AUDIO_DIALOG,
    UPDATE_VISUALIZER_REFLECTION_TYPE,
    SET_SHOW_ADVANCED_SETTINGS,
    SET_SHOW_UPDATE_DIALOG,
    SET_PREVIEW_RESOLUTION,
    UPDATE_IMAGES_LIBRARY,
    CLEAR_IMAGES_LIBRARY,
    UPDATE_LYRICS_SEGMENT,
    REMOVE_LYRICS_SEGMENT,
    REMOVE_LYRICS_SEGMENTS,
    SET_LYRICS_SEGMENT_TIME,
    ADD_LYRICS_SEGMENT,
    ADD_LYRICS_SEGMENTS,
    CLEAR_LYRICS,
    UNDO,
    REDO,
    CLEAR_ACTIONS_HISTORY,
    UPDATE_TEXT_ELEMENT,
    ADD_TEXT_ELEMENT,
    REMOVE_TEXT_ELEMENT,
    DUPLICATE_TEXT_ELEMENT,
    UPDATE_PARTICLE_ITEM,
    ADD_PARTICLE_ITEM,
    REMOVE_PARTICLE_ITEM,
    DUPLICATE_PARTICLE_ITEM,
    UPDATE_BACKGROUND_SETTINGS,
    UPDATE_LYRICS_STYLE,
    ADD_WAVE_LAYER,
    UPDATE_WAVE_LAYER,
    REMOVE_WAVE_LAYER,
    DUPLICATE_WAVE_LAYER,
    CHANGE_WAVE_LAYER_ORDER,
    UPDATE_VISUALIZER_SETTINGS,
    UPDATE_VISUALIZER_LAYERS_TYPE,
    UPDATE_WAVE_LAYER_SPIN_SETTINGS,
    UPDATE_WAVE_LAYER_CUSTOM_SETTINGS,
    SET_PREVIEW_PROPERTY_WITHOUT_TRACKING,
    SELECT_OR_DESELECT_SEGMENTS,
    UPDATE_ELEMENTS_SETTINGS,
    UPDATE_IMAGE_ELEMENT,
    ADD_IMAGE_ELEMENT,
    REMOVE_IMAGE_ELEMENT,
    DUPLICATE_IMAGE_ELEMENT,
    CHANGE_IMAGE_ELEMENT_ORDER,
    UPDATE_ASPECT_RATIO
}